import { MILESTONE_STATUS } from 'domain/shared/newProject';
import { getAsciiTextValidation } from 'framework/form';

const milestonesValidation = {
  id: {
    type: 'string',
    required: false,
  },
  alias: {
    type: 'string',
    required: false,
  },
  title: {
    type: 'string',
    required: true,
    errorMessage: 'Milestone is required',
    maxSize: 255,
    ...getAsciiTextValidation({
      '$.status': {
        nin: [MILESTONE_STATUS.COMPLETED, MILESTONE_STATUS.REJECTED],
      },
    }),
  },
  description: {
    type: 'string',
    required: false,
    ...getAsciiTextValidation({
      '$.status': {
        nin: [MILESTONE_STATUS.COMPLETED, MILESTONE_STATUS.REJECTED],
      },
    }),
  },
  initialPlannedDate: {
    type: 'date',
    required: {
      value: true,
      when: {
        '$.status': {
          nin: [MILESTONE_STATUS.COMPLETED, MILESTONE_STATUS.REJECTED],
        },
      },
      message: 'Please fill this field',
    },
  },
  currentPlannedDate: {
    type: 'date',
    required: false,
  },
  comment: {
    type: 'string',
    required: {
      value: true,
      when: {
        '$.currentPlannedDate': {
          nin: [null, undefined],
        },
      },
      message: 'Please fill the reason',
    },
    maxSize: {
      value: 255,
      when: {
        '$.currentPlannedDate': {
          nin: [null, undefined],
        },
      },
    },
    ...getAsciiTextValidation({
      _and_: [
        {
          '$.currentPlannedDate': {
            nin: [null, undefined],
          },
          '$.status': {
            nin: [MILESTONE_STATUS.COMPLETED, MILESTONE_STATUS.REJECTED],
          },
        },
      ],
    }),
  },

  status: {
    type: 'string',
    required: false,
  },
};

export const completeMilestoneValidation = {
  completionDate: {
    type: 'date',
    required: true,
  },
  initialPlannedDate: {
    type: 'date',
    required: {
      value: true,
      when: {
        '$.hasInitialPlannedDate': {
          eq: false,
        },
      },
      message: 'Please fill this field',
    },
  },
};

export const rejectMilestoneValidation = {
  rejectionReason: {
    type: 'string',
    required: true,
  },
};

export const milestonesDashboardValidation = {
  milestones: {
    type: 'array',
    forEach: {
      type: 'object',
      _divisible: false,
      properties: milestonesValidation,
    },
  },
};

const milestonesArrayValidation = {
  milestones: {
    type: 'array',
    forEach: {
      type: 'object',
      _divisible: false,
      properties: milestonesValidation,
    },
  },
};
export default milestonesArrayValidation;
